export enum TelemetrySdkEventGroup {
    Default = "default",
    Error = "error"
}
